"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOrder = exports.RowState = exports.localText = exports.tableRowPaddingLeftRight = exports.tableRowPaddingTopBottom = void 0;
exports.tableRowPaddingTopBottom = '16px';
exports.tableRowPaddingLeftRight = '20px';
exports.localText = {
    noResults: 'No results. Please try something else.',
};
var RowState;
(function (RowState) {
    RowState[RowState["Disabled"] = 0] = "Disabled";
    RowState[RowState["Highlighted"] = 1] = "Highlighted";
    RowState[RowState["Important"] = 2] = "Important";
})(RowState = exports.RowState || (exports.RowState = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["None"] = "None";
    SortOrder["ASC"] = "Asc";
    SortOrder["DESC"] = "Desc";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
